module.exports = __webpack_public_path__ + "img/159131702301.d98b8ab5.png";